<script>
import moment from 'moment'
import {mapGetters} from "vuex";
moment.locale('fr');

export default {
  name: "ParentMixin",
  components:{ 
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ])
  },
  data(){
    return {
      //PARAMS IF MOBILE AND IS LOADING
      isMobile:false,  
      isLoading:true,
      item:{
        src:'/img/loader.png'
      },      
    }
  },
  props:{
    //PASS PROPS IS LOADING
    isLoad:{
      type:Boolean,
      default: true
    },      
  },     
  created (){
    //CALL IF IS MOBILE
      this.isMobile = this.getIsMobile;
  },    
  methods : {
    //MODIFY DATE
    moment: function (date,year) {
      return moment(date,year);
    },
    //SWIPE
    swipeRightHandler () {
        this.goBack();
    },
  },
  watch : {
    //CHECK IF ISLOADING IS UPDATED
    'isLoad' : function (){
      this.isLoading = this.isLoad;    
    },
  },
  filters: {
    //REFACTOR THE DATE
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do MMMM YYYY';
      return moment(date).format($format);
    }
  }     
}
</script>
